export default "__VITE_ASSET__CAO15EIk__"